<!--  -->
<template>
  <div class="collect">
    <h3>我的收藏</h3>
    <div class="content">
      <div v-show="!done" class="nothing">
        <img src="../../assets/nosc.png" alt />
        <p>暂无收藏</p>
      </div>
      <ul v-show="done" class="infoList" v-loading.fullscreen.lock="fullscreenLoading">
        <li
          v-for="(item, index) in infoList"
          :key="index"
          @mouseenter="mouseEnter(index)"
          @mouseleave="mouseLeave"
          :class="{ shadow: index == isActive }"
        >
          <p class="title1" @click="gotoDetail(item.bidid)">{{ item.othertitle }}</p>
          <p class="title2" @click="gotoDetail(item.bidid)">{{ item.chinesetitle }}</p>
          <p class="info">
            <span v-if="item.didcustomer != null">customer：{{ item.didcustomer }}</span>
            <span v-if="item.reletime != null">发布日期：{{ item.reletime }}</span>
          </p>
          <p class="tagGroup">
            <span
              class="country"
              v-if="item.nationalFlag"
              @click="countrygotoFind(item.countrgions)"
            >
              {{ item.nationalFlag.chinesecountry
              }}
              <img
                :src="
                  `http://182.61.21.235/images/${item.nationalFlag.nfaddress}`
                "
                alt
              />
            </span>
            <span v-else>暂无地区信息</span>
            <el-tag
              size="small"
              v-if="item.labelo != null"
              @click="hotgotoFind(item.labelo)"
            >{{ item.labelo }}</el-tag>
            <el-tag
              size="small"
              v-if="item.labelt != null"
              @click="hotgotoFind(item.labelt)"
            >{{ item.labelt }}</el-tag>
            <el-tag
              size="small"
              v-if="item.lables != null"
              @click="hotgotoFind(item.lables)"
            >{{ item.lables }}</el-tag>
            <el-tag
              size="small"
              v-if="item.didbudget != null"
              type="warning"
              @click="hotgotoFind(item.didbudget)"
            >{{ item.didbudget }}</el-tag>
            <el-tag
              size="small"
              v-if="item.didnotice != null"
              type="danger"
              @click="hotgotoFind(item.didnotice)"
            >{{ item.didnotice }}</el-tag>
            <span class="kbrq" v-if="item.starttime != '' && item.starttime != null">
              <i class="el-icon-time"></i>
              开标日期：{{ item.starttime }}
            </span>
          </p>
        </li>
      </ul>
      <div class="pagination" v-show="done">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="10"
          :total="total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import tool from '../../tool/tool'
import { API_1, Global } from '@/conf/api'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'collect',
  components: {},
  data() {
    //这里存放数据
    return {
      infoList: [],
      uid: null,
      done: true, //是否有数据
      fullscreenLoading: false, //loading
      isActive: null, //鼠标进入列表样式
      total: 120,
      pages: 1,
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleCurrentChange(val) {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      document.body.scrollTop = document.documentElement.scrollTop = 0
      // 实现滚动效果
      if (top <= 0) {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
      }
      this.pages = val
      this.getList()
    },
    gotoDetail(id) {
      //跳转搜索页
      const { href } = this.$router.resolve({
        path: `detail`,
        query: { id: id },
      })
      window.open(href, '_blank')
    },
    hotgotoFind(val) {
      //跳转搜索页
      //跳转详情页
      const { href } = this.$router.resolve({
        path: `find`,
        query: { lable: val },
      })
      window.open(href, '_blank')
    },
    mouseEnter(index) {
      this.isActive = index
    },
    mouseLeave() {
      this.isActive = null
    },
    getList() {
      this.fullscreenLoading = true
      //行业
      let params = {
        cuid: this.uid,
        pages: this.pages,
      }
      this.axios
        .get(API_1 + Global.findsc, { params: params })
        .then((res) => {
          if (res.data.data == null) {
            this.done = false
          } else {
            this.infoList = res.data.data.list
            this.total = res.data.data.total
          }
          this.fullscreenLoading = false
        })
        .catch((res) => {})
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.uid = tool.getCookie('user')
    this.getList()
    this.$emit('status', 3)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.shadow {
  box-shadow: #0f72b7 0px 0px 18px;
}
.collect {
  //width: 1610px;
  min-height: 650px;
  min-width: 930px;
  background-color: #ffffff;
  margin: 10px;
  padding-top: 30px;
  .pagination {
    margin-top: 10px;
    border-radius: 6px;
    padding: 15px 40px;
    text-align: center;
    /deep/li {
      background: #f4f4f4;
      color: #666;
    }
    /deep/.active {
      background: #0f4d72 !important;
      color: #fff;
    }
  }
  h3 {
    width: 73px;
    height: 20px;
    font-family: MicrosoftYaHei;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #0f4d72;
    padding-left: 10px;
    border-left: 4px solid #0f4d72;
    margin-left: 50px;
    margin-bottom: 30px;
  }
  .content {
    border-top: 1px solid #eee;
    text-align: left;
    padding: 30px 50px 50px;
    .nothing {
      color: #a3bed7;
      font-size: 20px;
      text-align: center;
    }
    /deep/ .infoList {
      // width: 1509px;
      min-width: 860px;
      li {
        margin-top: 10px;
        //height: 170px;
        border-radius: 6px;
        background: #fff;
        padding: 15px 50px;
        text-align: left;
        height: 170px;
        box-sizing: border-box;
        border: solid 1px #eeeeee;
        &:hover {
          .title1,
          .title2 {
            color: #0f4d72;
          }
        }
        .title1,
        .title2 {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 800px;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
          color: #666;
          cursor: pointer;
        }
        .title2 {
          font-weight: inherit;
          margin-bottom: 20px;
        }
        .info {
          font-size: 12px;
          color: #999;
          margin-bottom: 20px;
          span {
            margin-right: 50px;
          }
        }
        .tagGroup {
          font-size: 12px;
          .el-tag {
            cursor: pointer;
            margin-left: 20px;
            vertical-align: middle;
            color: #0f4d72;
            background: rgba(15, 77, 114, 0.1);
            height: 24px;
            font-size: 12px;
            line-height: 21px;
            border: 1px solid transparent;
          }
          .country {
            cursor: pointer;
            img {
              width: 34px;
              height: 20px;
              margin-left: 10px;
              border: 1px solid #dcdcdc;
            }
          }
          .kbrq {
            font-size: 14px;
            float: right;
            color: #0f4d72;
          }
        }
      }
    }
  }
}
</style>
